import './mqtt-patch';import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../src/theme';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { SnackbarProvider } from 'notistack';
import { AuthProvider } from 'react-oidc-context';

const oidcConfig: any = {
  authority: process.env.REACT_APP_OIDC_AUTHORIY,
  client_id: process.env.REACT_APP_OIDC_CLIENT_ID,
  redirect_uri: window.location.origin,
  post_logout_redirect_uri: window.location.origin,
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <AuthProvider {...oidcConfig}>
    <Provider store={store}>      
          <App />
    </Provider>
  </AuthProvider>
);
